(function () {
  'use strict';

  function parseQty(value) {
    if (!value) return 0;
    var cleaned = String(value)
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/unidades?/g, '')
      .replace(/\bun\b/g, '')
      .replace(/un$/g, '')
      .replace(/\+/g, '')
      .replace(/kit/g, '')
      .replace(/pcs?/g, '');
    var match = cleaned.match(/(\d+)/);
    if (!match) return 0;
    var n = parseInt(match[1], 10);
    return isNaN(n) ? 0 : n;
  }

  function SizeDist(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.optionIndex = parseInt(root.getAttribute('data-option-index'), 10);
    this.required = root.getAttribute('data-required') !== 'false';
    this.packageQty = parseInt(root.getAttribute('data-package-qty'), 10) || 0;

    // If packageQty is 0, try to find the main quantity input for this section
    if (this.packageQty === 0) {
      this.qtyInput = document.querySelector('#Quantity-' + this.sectionId);
      if (this.qtyInput) {
        this.packageQty = parseInt(this.qtyInput.value, 10) || 0;
      }
    }

    this.counterCurrent = root.querySelector('[data-sd-current]');
    this.counterTarget = root.querySelector('[data-sd-target]');
    this.statusEl = root.querySelector('[data-sd-status]');
    this.summaryProp = root.querySelector('[data-sd-summary]');
    this.totalProp = root.querySelector('[data-sd-total-prop]');
    this.packageProp = root.querySelector('[data-sd-package-prop]');

    this.values = {}; // size -> qty
    this.sizes = [];

    var self = this;
    root.querySelectorAll('[data-sd-display]').forEach(function (el) {
      var size = el.getAttribute('data-sd-display');
      self.sizes.push(size);
      self.values[size] = 0;
    });

    this.bind();
    this.render();
  }

  SizeDist.prototype.bind = function () {
    var self = this;

    this.root.querySelectorAll('[data-sd-inc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.step(btn.getAttribute('data-size'), 1);
      });
    });
    this.root.querySelectorAll('[data-sd-dec]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.step(btn.getAttribute('data-size'), -1);
      });
    });

    // Listen to main quantity input changes if we are in dynamic mode
    if (this.qtyInput) {
      var handleQtyChange = function() {
        var newQty = parseInt(self.qtyInput.value, 10) || 0;
        if (newQty !== self.packageQty) {
          self.packageQty = newQty;
          self.render();
        }
      };
      this.qtyInput.addEventListener('input', handleQtyChange);
      this.qtyInput.addEventListener('change', handleQtyChange);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !data.variant) return;
        if (String(data.sectionId) !== String(self.sectionId)) return;
        
        // Update variant price reference if needed (optional here as SD doesn't show price)
        
        // If we are in volume mode (optionIndex >= 0), update packageQty from variant
        if (!isNaN(self.optionIndex) && self.optionIndex >= 0 && data.variant.options) {
          var optionValue = data.variant.options[self.optionIndex];
          var newQty = parseQty(optionValue);
          if (newQty > 0) self.packageQty = newQty;
        } else if (self.qtyInput) {
          // If in dynamic mode, just ensure we match current input value
          self.packageQty = parseInt(self.qtyInput.value, 10) || 0;
        }

        self.render();
        requestAnimationFrame(function () {
          self.setSubmitState(self.sum() === self.packageQty);
        });
      });
    }
  };

  SizeDist.prototype.step = function (size, delta) {
    if (!(size in this.values)) return;
    var next = this.values[size] + delta;
    if (next < 0) next = 0;
    // Não deixa estourar acima do pacote num único passo.
    var others = this.sum() - this.values[size];
    if (delta > 0 && others + next > this.packageQty) {
      next = Math.max(this.values[size], this.packageQty - others);
    }
    this.values[size] = next;
    this.render();
  };

  SizeDist.prototype.sum = function () {
    var total = 0;
    for (var k in this.values) {
      if (this.values.hasOwnProperty(k)) total += this.values[k];
    }
    return total;
  };

  SizeDist.prototype.render = function () {
    var self = this;
    var total = this.sum();
    var target = this.packageQty;

    // Displays + steppers
    this.sizes.forEach(function (size) {
      var disp = self.root.querySelector('[data-sd-display="' + CSS.escape(size) + '"]');
      if (disp) disp.textContent = self.values[size];
      var inc = self.root.querySelector('[data-sd-inc][data-size="' + CSS.escape(size) + '"]');
      if (inc) inc.disabled = total >= target;
      var dec = self.root.querySelector('[data-sd-dec][data-size="' + CSS.escape(size) + '"]');
      if (dec) dec.disabled = self.values[size] <= 0;
    });

    if (this.counterCurrent) this.counterCurrent.textContent = total;
    if (this.counterTarget) this.counterTarget.textContent = target;

    var valid = total === target;
    var state, msg;
    if (total === 0) {
      state = 'neutral';
      msg = 'Distribua as ' + target + ' unidades entre os tamanhos';
    } else if (total < target) {
      state = 'incomplete';
      msg = 'Faltam ' + (target - total) + ' unidade' + (target - total === 1 ? '' : 's');
    } else if (total > target) {
      state = 'excess';
      msg = 'Remova ' + (total - target) + ' unidade' + (total - target === 1 ? '' : 's');
    } else {
      state = 'complete';
      msg = 'Distribuição completa';
    }

    this.root.setAttribute('data-sd-state', state);
    if (this.statusEl) this.statusEl.textContent = msg;

    this.syncProps(valid);
    this.setSubmitState(valid);
  };

  SizeDist.prototype.syncProps = function (valid) {
    var self = this;
    var parts = [];

    this.sizes.forEach(function (size) {
      var input = self.root.querySelector('[data-sd-prop="' + CSS.escape(size) + '"]');
      if (!input) return;
      var qty = self.values[size];
      input.value = qty;
      // Só submete tamanhos com qty > 0 e quando a distribuição fecha.
      input.disabled = !(valid && qty > 0);
      if (qty > 0) parts.push(size + ': ' + qty);
    });

    var summary = parts.join(' | ');
    if (this.summaryProp) {
      this.summaryProp.value = summary;
      this.summaryProp.disabled = !(valid && parts.length > 0);
    }
    if (this.totalProp) {
      this.totalProp.value = this.sum() + ' unidades';
      this.totalProp.disabled = !valid;
    }
    if (this.packageProp) {
      this.packageProp.value = this.packageQty + ' unidades';
      this.packageProp.disabled = !valid;
    }
  };

  SizeDist.prototype.setSubmitState = function (valid) {
    if (!this.required) return;
    var btn = document.getElementById('ProductSubmitButton-' + this.sectionId);
    if (!btn) return;
    var form = btn.closest('form');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var unavailable = idInput ? idInput.disabled : false;
    btn.disabled = unavailable || !valid;
  };

  function init() {
    var roots = document.querySelectorAll('[data-tiger-size-dist]');
    roots.forEach(function (root) {
      if (root.__sizeDist) return;
      root.__sizeDist = new SizeDist(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
